<section class="app-dialog pruebas-dialogo" [attr.aria-busy]="guardando">
  <header class="app-dialog__header">
    <div class="app-dialog__heading">
      <div>
        <p class="app-dialog__eyebrow">Gestión de Proyectos</p>
        <h2 [id]="idTitulo">Crear incidencia</h2>
        <p *ngIf="subtitulo">{{ subtitulo }}</p>
      </div>
    </div>
    <button type="button" class="app-dialog__close app-dialog__close--icono" aria-label="Cerrar" title="Cerrar"
            [disabled]="guardando" (click)="cancelar()">
      <span class="material-icons" aria-hidden="true">close</span>
    </button>
  </header>

  <div mat-dialog-content class="app-dialog__content pruebas-dialogo__contenido">
    <section class="pruebas-dialogo__seccion" aria-labelledby="t2i-donde">
      <h3 id="t2i-donde" class="pruebas-dialogo__titulo">Dónde se detectó</h3>
      <dl class="pruebas-dialogo__fijos">
        <div class="pruebas-dialogo__fijo">
          <dt>Etapa</dt>
          <dd>{{ datos.nombreEtapa || "Sin nombre" }}</dd>
        </div>
        <div class="pruebas-dialogo__fijo">
          <dt>Versión detectada</dt>
          <dd>{{ datos.etiquetaVersion }}</dd>
          <dd class="pruebas-dialogo__ayuda">La versión que se está probando</dd>
        </div>
        <div class="pruebas-dialogo__fijo">
          <dt>Ejecución de pruebas</dt>
          <dd>{{ datos.etiquetaEjecucion }}</dd>
          <dd class="pruebas-dialogo__ayuda">Se agrega a sus incidencias levantadas</dd>
        </div>
      </dl>
    </section>

    <section class="pruebas-dialogo__seccion" aria-labelledby="t2i-datos">
      <h3 id="t2i-datos" class="pruebas-dialogo__titulo">Datos de la incidencia</h3>
      <form class="incidencia-rapida__campos" [formGroup]="formulario" autocomplete="off">
        <!-- mat-label es la etiqueta que se ve; la <label for> oculta es la que leen los lectores de pantalla. -->
        <mat-form-field appearance="outline" class="table-page__field incidencia-rapida__completo" subscriptSizing="dynamic">
          <mat-label aria-hidden="true">Título</mat-label>
          <label class="cdk-visually-hidden" for="t2i-titulo-inc">Título</label>
          <input matInput id="t2i-titulo-inc" formControlName="titulo" required [maxlength]="largoTitulo" />
          <mat-hint align="end">{{ largo("titulo") }}/{{ largoTitulo }}</mat-hint>
          <mat-error *ngIf="error('titulo', 'required')">Escribe el título de la incidencia.</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
          <mat-label>Prioridad</mat-label>
          <mat-select formControlName="prioridad" required>
            <mat-option *ngFor="let prioridad of prioridades" [value]="prioridad">
              <span class="app-prioridad" [ngClass]="clasePrioridad(prioridad)">{{ prioridad }}</span>
            </mat-option>
          </mat-select>
          <mat-error *ngIf="error('prioridad', 'required')">Elige la prioridad.</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
          <mat-label>Tipo</mat-label>
          <mat-select formControlName="tipo" required>
            <mat-option *ngFor="let tipo of tipos" [value]="tipo">{{ tipo }}</mat-option>
          </mat-select>
          <mat-error *ngIf="error('tipo', 'required')">Elige el tipo.</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="table-page__field incidencia-rapida__completo" subscriptSizing="dynamic">
          <mat-label aria-hidden="true">Descripción</mat-label>
          <label class="cdk-visually-hidden" for="t2i-descripcion">Descripción</label>
          <textarea matInput id="t2i-descripcion" rows="5" formControlName="descripcion" required
                    [maxlength]="largoDescripcion"></textarea>
          <mat-hint align="end">{{ largo("descripcion") }}/{{ largoDescripcion }}</mat-hint>
          <mat-error *ngIf="error('descripcion', 'required')">Describe el defecto y cómo reproducirlo.</mat-error>
        </mat-form-field>
      </form>
    </section>

    <section class="pruebas-dialogo__seccion" aria-labelledby="t2i-evidencia-titulo">
      <h3 id="t2i-evidencia-titulo" class="pruebas-dialogo__titulo">
        Evidencia <span class="pruebas-dialogo__opcional">· Opcional</span>
      </h3>
      <input #entrada id="t2i-evidencia" type="file" class="cdk-visually-hidden" multiple [accept]="acepta"
             [disabled]="guardando" (change)="elegirArchivos(entrada)" />
      <label for="t2i-evidencia" class="pruebas-dialogo__soltar" (dragover)="permitirSoltar($event)" (drop)="soltar($event)">
        <span class="material-icons pruebas-dialogo__soltar-icono" aria-hidden="true">upload_file</span>
        <span class="pruebas-dialogo__soltar-texto">
          <strong>Adjuntar evidencia</strong>
          <span>Arrastre archivos aquí o <span class="pruebas-dialogo__enlace">seleccione un archivo</span></span>
          <small>Imágenes, videos o documentos del defecto</small>
        </span>
      </label>
      <p class="pruebas-dialogo__error" role="alert" *ngIf="avisoArchivos">{{ avisoArchivos }}</p>
      <ul class="pruebas-dialogo__archivos" *ngIf="archivos.length" aria-label="Archivos agregados">
        <li *ngFor="let archivo of archivos; let i = index">
          <span class="pruebas-dialogo__archivo">
            <strong>{{ archivo.name }}</strong>
            <span>{{ lineaArchivo(archivo) }}</span>
          </span>
          <button type="button" class="table-page__action-btn" title="Quitar" [attr.aria-label]="'Quitar ' + archivo.name"
                  [disabled]="guardando" (click)="quitarArchivo(i)">
            <span class="material-icons" aria-hidden="true">close</span>
          </button>
        </li>
      </ul>
    </section>

    <div class="app-aviso-info pruebas-dialogo__info">
      <span class="material-icons" aria-hidden="true">info</span>
      <p>Se registra en <strong>ABIERTO</strong> al crearla y queda registrada aunque no se guarde la ejecución.</p>
    </div>

    <p class="pruebas-dialogo__error" role="alert" *ngIf="mensaje">{{ mensaje }}</p>
  </div>

  <footer mat-dialog-actions class="app-dialog__footer">
    <span class="pruebas-dialogo__obligatorios">* Campos obligatorios</span>
    <button type="button" class="app-form-btn app-form-btn--secondary" [disabled]="guardando" (click)="cancelar()">Cancelar</button>
    <button type="button" class="app-form-btn app-form-btn--primary" [attr.aria-busy]="guardando" [disabled]="guardando" (click)="crear()">
      {{ guardando ? "Creando…" : "Crear y vincular" }}
    </button>
  </footer>
</section>
